import { linkedInBlue, primaryGreen, lightPurple } from '@styles/colors';

export const getEventColor = (title: string) => {
  if (title === 'Direct Interview') return linkedInBlue;
  if (title === 'Open Interviews') return lightPurple;
  if (title === 'Interview Block') return primaryGreen;
  return linkedInBlue;
};
